import React from "react";
import SubHome from "../components/SubHome";
import "../styles/pages/contactus.css";
import Footer from "../components/Footer";

const ContactUs = () => {
  return (
    <>
      <SubHome mainHeading="Contact" listItem="Contact" />
      <div className="contact-container">
        <div className="contact-sub-container">
          {/* <h6 className="main-sub-heading">Have any Questions...!</h6>
          <h2 className="main-heading">Contact Information</h2>
          <div className="heading-border"></div> */}

          <div className="contact-form-box">
            <h6 className="main-sub-heading">Have A Question</h6>
            <h2 className="main-heading">Send Message</h2>
            <div
              className="heading-border"
              style={{ marginBottom: "50px" }}
            ></div>
            <div className="form-row">
              <input type="text" className="form-field" placeholder="Name" />
              <input type="email" className="form-field" placeholder="Email" />
            </div>
            <div className="form-row">
              <input type="tel" className="form-field" placeholder="Phone" />
              <input type="text" className="form-field" placeholder="Subject" />
            </div>
            <div className="form-row">
              <textarea
                name=""
                id=""
                cols="30"
                placeholder="Message"
                rows="10"
                className="form-textarea"
              ></textarea>
            </div>
            <button className="contact-btn">Contact Us</button>
          </div>
        </div>
      </div>

    </>
  );
};

export default ContactUs;
